import { Sort } from "@/components/_types/sort";
import { notFound } from "next/navigation";

export const getCategoriesSliders = async (
	kind: string,
	genre?: string,
	title?: string,
	sortObj?: Sort,
) => {
	if (
		kind !== "movies" &&
		kind !== "series" &&
		kind !== "games" &&
		kind !== "board-games"
	) {
		notFound();
	}
	const url = new URL(`${process.env.NEXT_PUBLIC_API_URL}/public/page/${kind}`);

	if (title) {
		url.searchParams.append("title", title);
	}

	if (genre) {
		url.searchParams.append("genres", genre);
	}

	if (sortObj) {
		url.searchParams.append("sortBy", sortObj?.sortBy);
		url.searchParams.append("direction", sortObj?.direction);
	}

	const res = await fetch(url.toString(), {
		method: "GET",
		headers: {
			"Content-Type": "application/json",
		},
		cache: "no-store",
	});

	if (!res.ok) throw new Error("Failed to fetch Slides");
	return res.json();
};
